import { SOURCE_LABELS } from "./trafficShape";

export function fmtNum(v) {
	if (v == null || Number.isNaN(Number(v))) return "—";
	const n = Number(v);
	if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
	if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
	return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

export function fmtDate(isoDate) {
	if (!isoDate) return "—";
	const d = new Date(`${isoDate}T00:00:00`);
	if (Number.isNaN(d.getTime())) return isoDate;
	return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export function fmtDateTime(iso) {
	if (!iso) return "—";
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return iso;
	return d.toLocaleString(undefined, {
		day: "numeric",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}

export function fmtShortDate(s) {
	if (!s) return "—";
	const d = new Date(`${s}T00:00:00`);
	if (Number.isNaN(d.getTime())) return s;
	return d.toLocaleDateString(undefined, {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

export function toSeries(byAssistant, labels) {
	if (!byAssistant || typeof byAssistant !== "object") return [];
	return Object.entries(byAssistant).map(([assistant, points]) => ({
		engine: assistant,
		label: labels?.[assistant] ?? assistant,
		points: (points || []).map((p) => ({ date: p.date, value: p.value })),
	}));
}

export function axisMax(byAssistant) {
	const peak = Math.max(
		0,
		...Object.values(byAssistant || {})
			.flat()
			.map((p) => p?.value ?? 0)
	);
	return peak <= 0 ? 10 : Math.ceil((peak * 1.15) / 10) * 10;
}

export function dataDays(sel) {
	if (!sel?.range?.start || !sel?.range?.end) return 14;
	return (
		Math.round(
			(Date.parse(`${sel.range.end}T00:00:00`) -
				Date.parse(`${sel.range.start}T00:00:00`)) /
				86400000
		) + 1
	);
}

export function sourceLabel(source) {
	if (!source) return null;
	return SOURCE_LABELS[source] ?? source;
}

export function compareLabel(comparison) {
	if (!comparison?.start || !comparison?.end) return undefined;
	return `vs ${comparison.start} – ${comparison.end}`;
}
